import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { HiX } from "react-icons/hi";
import { translate } from "ui/i18n";
import { BetaPill } from "ui/pages/app/components/activities/BetaPill";
export const CustomTooltip = ({
  open,
  onClose,
  children,
  title,
  text,
  className,
  beta,
}: PropsWithChildren<{
  open: boolean;
  onClose: () => void;
  title: string;
  text: string;
  className?: string;
  beta?: boolean;
}>) => {
  const handleClose = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent?.stopImmediatePropagation?.();
    onClose();
  };

  const handleContentClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent?.stopImmediatePropagation?.();
  };
  return (
    <Popover isOpen={open} closeOnBlur={false}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent
        className={`popover-tooltip max-w-[340px] ${className}`}
        border="none"
        bg="transparent"
        onClick={handleContentClick}
        onMouseDown={handleContentClick}
        onMouseUp={handleContentClick}
        cursor="default"
      >
        <PopoverArrow bg="#2d396b" border="none" />
        <div
          style={{ fontFamily: "Plus Jakarta Sans" }}
          className="relative rounded-lg bg-darkGrey-800 p-4 text-white"
          onClick={handleContentClick}
          onMouseDown={handleContentClick}
        >
          <div className="items-top flex justify-between">
            {beta && <BetaPill className="mb-2" />}
            {!beta && <p className="text-base font-bold text-white">{title}</p>}
            <button
              onClick={handleClose}
              className="z-50 flex h-4 w-4 items-center"
            >
              <HiX size={16} className="text-white" />
            </button>
          </div>
          {beta && <p className="text-base font-bold text-white">{title}</p>}
          <p className="mt-1 text-sm text-white">{text}</p>
          <button
            className="mt-3 rounded-xl bg-white px-4 py-2 text-sm font-semibold text-darkGrey-800"
            onClick={handleClose}
          >
            {translate("ns1:Button.Understood")}
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
